module.exports = __webpack_public_path__ + "media/images/icons/outlined/audio-muted-e612d61a72adf5956c79fe85a6343133.svg";